var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3654",
    "data-name": "Rectangle 3654",
    width: 28.346,
    height: 28.35,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8822",
    "data-name": "Group 8822",
    transform: "translate(9241 15400)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8821",
    "data-name": "Group 8821",
    transform: "translate(-9239 -15399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8820",
    "data-name": "Group 8820",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6430",
    "data-name": "Path 6430",
    d: "M28.346,6.373V22.039c-.087.026-.058.106-.067.162a6.878,6.878,0,0,1-.437,1.646,7.085,7.085,0,0,1-4.7,4.236c-.4.12-.821.131-1.217.266H6.314c-.022-.073-.087-.054-.137-.062a6.993,6.993,0,0,1-1.238-.278A7.1,7.1,0,0,1,.007,21.218C-.006,16.532,0,11.846,0,7.16a6.608,6.608,0,0,1,.609-2.9A6.962,6.962,0,0,1,7.263.015C11.857-.013,16.451.009,21.044.006a7.157,7.157,0,0,1,2.809.509A7.074,7.074,0,0,1,28.08,5.209c.115.384.119.79.266,1.164M14.169,7.651c-2.075.039-4.151.067-6.222.215a2.56,2.56,0,0,0-1.32.437,2.883,2.883,0,0,0-1.084,2.265,42.126,42.126,0,0,0-.109,5.557,12.379,12.379,0,0,0,.217,2.365,2.225,2.225,0,0,0,1.951,1.9,11.108,11.108,0,0,0,1.623.145,99.59,99.59,0,0,0,11.063-.053,2.472,2.472,0,0,0,1.79-.74,3.269,3.269,0,0,0,.73-1.958,43.647,43.647,0,0,0,.107-5.53A13.053,13.053,0,0,0,22.7,9.891a2.357,2.357,0,0,0-2.312-2.026c-2.071-.145-4.147-.174-6.222-.214",
    transform: "translate(0 0)",
    fill: "#998242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6431",
    "data-name": "Path 6431",
    d: "M175.408,166.871v-5.164l4.761,2.6-4.761,2.561",
    transform: "translate(-163.048 -150.312)",
    fill: "#998242"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3657",
    "data-name": "Rectangle 3657",
    transform: "translate(-9241 -15400)",
    fill: "none",
    stroke: "#998242",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 27,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.3d03c5aa9fc9ff7c01f6baa2420921ad.svg";
export { ForwardRef as ReactComponent };